// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateSearchQuery = (state, action) => action.query;

export default (state = getDefaultState().searchQueryString, action) => {

    const actionTypes = {
        [actions.UPDATE_RGA_SEARCH_QUERY_STRING]: updateSearchQuery
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/rga/search/reducers/search-query-string.js